<template>
  <div class="backdrop">
    <div class="flex-column">
      <div class="flex-item">
        <img class="logo" src="@/assets/weavr-logo.svg">
      </div>
      <div class="flex-item">
        <span class="weavr-text">
          Weavr
        </span>
      </div>
      <div class="flex-item">
        <span class="not-found-message">
          The page you're looking for doesn't exist.
        </span>
      </div>
      <div class="flex-item">
        <span
          class="home-button"
          @click="goHome()"
        >
          Take me back home!
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  name: 'Page404',
  methods: {
    goHome() {
      this.$router.push({
        name: 'home'
      });
    }
  }
})
</script>

<style scoped lang="scss">
.backdrop {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}

.flex-column {
  position: absolute;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: max-content;
  text-align: center;
  font-size: 1.4em;
  top: 10%;
  left: 50%;
  transform: translateX(-50%);
}

.flex-item {
  flex: 0;
  display: flex;
}

.weavr-text {
  font-size: 1em;
  padding: 0.4em 0;
  margin: 0 auto;
  color: $brand-teal;
}

.logo {
  height: 6em;
  width: 6em;
  margin: 0 auto;
}

.not-found-message {
  margin: 0 auto;
  font-size: 1.4em;
  padding: 2em 0;
}

.home-button {
  margin: 0 auto;
  padding: 0.8em 1.2em;
  border-radius: 0.4em;
  color: $natural-white;
  background-color: $brand-teal;
}

.home-button:hover {
  cursor: pointer;
  background-color: $dark-cyan;
}
</style>
